import React, { createContext, useContext, useState, useEffect } from 'react';
import fr from '../locales/fr.json';
import ar from '../locales/ar.json';

const LanguageContext = createContext();

const translations = { fr, ar };

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('appLang') || 'fr');

  useEffect(() => {
    localStorage.setItem('appLang', lang);
    // Dynamically update document direction for Arabic support
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
    window.currentLang = lang;
  }, [lang]);

  const t = (key, interpolations = {}) => {
    const currentDict = translations[lang] || translations['fr'];
    let translated = currentDict[key] || key;

    // Support string interpolation (e.g. "{percent}% repaid")
    Object.keys(interpolations).forEach(keyName => {
      translated = translated.replace(`{${keyName}}`, interpolations[keyName]);
    });

    return translated;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
